import { z } from 'zod';
import { dateBeforeOnOCSCheck, getDateTimeInputValues } from '../config';
import { OCSForm } from '../types';
import { CaseFacility } from '@/api/apis/case';
import { createDateTimeFields } from '@/utils/helpers';

export const ocsSchema = z.object(
  createDateTimeFields({
    date: 'date',
    time: 'time',
    timezone: 'timeZone',
  }) as {
    date: z.ZodString;
    time: z.ZodString;
    timeZone: z.ZodString;
  },
);

export const offOcsSchema = ocsSchema
  .extend({
    onOcsTimestamp: z.string(),
  })
  .refine(dateBeforeOnOCSCheck<OCSForm>('date', 'time', 'timeZone'), {
    error: "Off OCS time can't be before On OCS time",
    path: ['date'],
  });

export const getOcsDefaultValues = (facility?: CaseFacility, ocsStartTimestamp?: string) => {
  const { date, time, timeZone } = getDateTimeInputValues(facility);

  return {
    date,
    time,
    timeZone,
    onOcsTimestamp: ocsStartTimestamp,
  };
};
